<button mat-button color="primary-outline" [routerLink]="['/clients/' + client_id + '/contacts-persons/create']">Contactpersoon toevoegen</button>
<ng-container *ngIf="smallWidget === false">
	<button mat-button color="primary-outline" [routerLink]="['/clients/' + client_id + '/view']">Bekijk klant</button>
	<button mat-button color="primary-outline" [routerLink]="['/clients']">Bekijk alle klanten</button>
	<app-search-element (formSubmittedEvent)="search($event)"></app-search-element>
</ng-container>
<mat-nav-list *ngIf="clientContactsPersons.length" class="mat-nav-list-with-border">
	<div *ngIf="!smallWidget" infiniteScroll infiniteScrollDistance="1" (scrolled)="getClientContactsPersons()"></div>
	<mat-list-item *ngFor="let contactPerson of clientContactsPersons">
		<div class="mat-list-content" [routerLink]="['/clients/' + contactPerson.client_id + '/contacts-persons/' + contactPerson.id + '/edit']">
			<h4 matLine>{{ contactPerson.firstname }} {{ contactPerson.lastname }}</h4>
			<a matLine>
				<mat-icon>email</mat-icon>
				<span *ngIf="contactPerson.email">{{ contactPerson.email }}</span>
				<span *ngIf="!contactPerson.email">-</span>
				/
				<mat-icon>phone</mat-icon>
				<span *ngIf="contactPerson.telephone">{{ contactPerson.telephone }}</span>
				<span *ngIf="!contactPerson.telephone">-</span>
				/
				<mat-icon>phone</mat-icon>
				<span *ngIf="contactPerson.mobile">{{ contactPerson.mobile }}</span>
				<span *ngIf="!contactPerson.mobile">-</span>
			</a>
		</div>
		<button mat-icon-button [matMenuTriggerFor]="menu">
			<mat-icon>more_vert</mat-icon>
		</button>
		<mat-menu #menu="matMenu">
			<a mat-menu-item [routerLink]="['/clients/' + contactPerson.client_id + '/contacts-persons/' + contactPerson.id + '/edit']">
				<mat-icon>edit</mat-icon>
				<span>Aanpassen</span>
			</a>
			<a mat-menu-item (click)="deleteClientContactPerson(contactPerson.client_id, contactPerson.id)">
				<mat-icon class="icon-danger">delete</mat-icon>
				<span>Verwijderen</span>
			</a>
		</mat-menu>
	</mat-list-item>
	<a mat-list-item *ngIf="smallWidget === true && totalItems > 5" [routerLink]="['/clients/' + client_id + '/contacts-persons']" class="mat-list-item-more">
		<span matLine>Bekijk meer ...</span>
		<button mat-icon-button>
			<mat-icon>chevron_right</mat-icon>
		</button>
	</a>
</mat-nav-list>
<div *ngIf="!clientContactsPersons.length">
	<br> Geen contactpersonen gevonden.
</div>
